import { useTitle } from '@vueuse/core';
import { n, t } from '~/plugins/i18n';
import { isEmpty, isUndefined } from 'lodash-es';
import { RouteLocationNormalized } from 'vue-router';
import { Locale } from '~/plugins/i18n/_types';
import config from '~/plugins/config';
import localeIsoCodes from '~/plugins/i18n/isoCodes.json';
import { LocalizedArray, LocalizedValue } from '~/api/links/_types';

/**
 * Set page title
 * @param route
 */
export const setPageTitle = (route: RouteLocationNormalized): void => {
    const pageName = route.name?.toString();

    if (isUndefined(pageName)) {
        useTitle(t('app.title'));
        return;
    }

    useTitle(t(`pages.${pageName}`), { titleTemplate: `${t('pages.main_title')} | %s` });
};

/**
 * Get locale ISO Code
 * @param locale
 */
export const getLocaleIsoCode = (locale: Locale | string): string =>
    localeIsoCodes[<Locale>locale] || config.app.locale;

export const getSupportedLocales = () => config.app.availableLocales;

export const getLocalizedValue = (locale: Locale, val: LocalizedValue): string => {
    for (const loc of [locale, ...config.app.fallbackLocale]) {
        if (loc in val && !isEmpty(val[loc])) return val[loc] ?? '';
    }

    return '';
};

export const getLocalizedArray = (locale: Locale, val: LocalizedArray): string[] => {
    for (const loc of [locale, ...config.app.fallbackLocale]) {
        if (loc in val && !isEmpty(val[loc])) return val[loc] ?? [];
    }

    return [];
};

export const formatNumber = (val: number) => {
    return n(val, {}, 'cs');
};
